const HEADER_SELECTOR = '.header';
const ANNOUNCEMENT_BAR_ID = 'shopify-section-announcement-bar';
const HAMBURGER_OPEN_SELECTOR = '.open-header-menu';
const HAMBURGER_CLOSE_SELECTOR = '.close-header-menu';
const HEADER_NAV_WRAPPER_SELECTOR = '.header__nav-wrapper';
const MENU_LIST_SELECTOR = '.header-menu__list';
const MENU_ITEM_SELECTOR = '.header-menu__item--dropdown';
const MOBILE_MENU_ITEM_SELECTOR = '.header-menu__list--mobile .header-menu__item--dropdown';
const OPEN_MENU_ITEM_SELECTOR = '.header-menu__item--dropdown.js--is-open';
const DESKTOP_TOP_MENU_ITEM_SELECTOR = '.header-menu__list--desktop .header-menu__item--level-1.header-menu__item--dropdown';
const MENU_BUTTON_SELECTOR = '.header-menu__button';
const MOBILE_MENU_BUTTON_SELECTOR = '.header-menu__list--mobile .header-menu__button';
const DESKTOP_MENU_BUTTON_SELECTOR = '.header-menu__list--desktop .header-menu__button';
const MOBILE_MENU_LINK_SELECTOR = '.header-menu__list--mobile .header-menu__link';
const DESKTOP_MENU_LINK_SELECTOR = '.header-menu__list--desktop .header-menu__link';
const MENU_BACK_BUTTON_SELECTOR = '.header-menu__back .back__button';
const HAMBURGER_CLASS = 'header__link--menu';
const MENU_WRAPPER_SELECTOR = '.header__nav-wrapper';

const HEADER_NAV_WRAPPER_SLIDE_CLASS = 'mobile-slide';
const LEVEL_1_MENU_ITEM_CLASS = 'header-menu__item--level-1';
const LEVEL_1_MENU_LIST_CLASS = 'header-menu__list--level-1';
const LEVEL_2_MENU_LIST_CLASS = 'header-menu__list--level-2';
const MENU_BUTTON_CLASS = 'header-menu__button';
const MENU_BACK_BUTTON_CLASS = 'back__button';
const MENU_LINK_EMPTY_CLASS = 'header-menu__link--empty';
const OPEN_CLASS = 'js--is-open';
const NO_SCROLL_CLASS = 'noscroll';
const OVERFLOW_CLASS = 'overflow-hidden';

const INTERACTION_KEYS = [' ', 'Enter', 'Escape', 'Tab'];

function throttle(callback, delay) {
    let shouldWait = false;

    return (...args) => {
        if (shouldWait) return;

        callback(...args);
        shouldWait = true;
        setTimeout(() => {
            shouldWait = false;
        }, delay);
    };
}

function initMobileMenu() {
    const menu = {
        $body: document.querySelector('body'),
        $header: document.querySelector(HEADER_SELECTOR),
        $headerNavWrapper: document.querySelector(HEADER_NAV_WRAPPER_SELECTOR),
        $hamburgerOpen: document.querySelector(HAMBURGER_OPEN_SELECTOR),
        $hamburgerClose: document.querySelector(HAMBURGER_CLOSE_SELECTOR),
        $items: document.querySelectorAll(MOBILE_MENU_ITEM_SELECTOR),
        $buttons: document.querySelectorAll(MOBILE_MENU_BUTTON_SELECTOR),
        $links: document.querySelectorAll(MOBILE_MENU_LINK_SELECTOR)
    };

    initMenuButtons(menu, 'mobile');
    initMenuLinks(menu, 'mobile');
}

function initDesktopMenu() {

    const menu = {
        $topLevelItems: document.querySelectorAll(DESKTOP_TOP_MENU_ITEM_SELECTOR),
        $buttons: document.querySelectorAll(DESKTOP_MENU_BUTTON_SELECTOR),
        $links: document.querySelectorAll(DESKTOP_MENU_LINK_SELECTOR)
    };

    initDesktopHover(menu.$topLevelItems);
    initMenuButtons(menu, 'desktop');
    initMenuLinks(menu, 'desktop');
}

function initMenuButtons(menu, source) {
    menu.$buttons.forEach(function (button) {
        button.menu = menu;
        button.source = source;
        button.type = 'button';

        button.addEventListener('click', handleClick);
        button.addEventListener('keydown', handleKeydown);
    });

    // If we're on mobile and using the slide layout, initialize back buttons
    if (source === 'mobile' && menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
        const backButtons = document.querySelectorAll(MENU_BACK_BUTTON_SELECTOR);

        backButtons.forEach(function (button) {
            button.menu = menu;
            button.source = source;
            button.type = 'back-button';

            button.addEventListener('click', handleClick);
            button.addEventListener('keydown', handleKeydown);
        });
    }
}

function initMenuLinks(menu, source) {
    menu.$links.forEach(function (link) {
        link.menu = menu;
        link.source = source;
        link.type = 'link';

        link.addEventListener('click', handleClick);
        link.addEventListener('keydown', handleKeydown);
        link.addEventListener('focus', handleFocus);
    });
}

function initDesktopHover(topLevelItems) {
    topLevelItems.forEach(function (item) {
        item.addEventListener('mouseenter', handleHover);
        item.addEventListener('mouseleave', handleHover);
    });
}

function handleClick(event) {
    const $this = event.currentTarget;

    event.stopPropagation();

    if ($this.type === 'button') {
        handleMenuButtonInteraction($this, event);
    } else if ($this.type === 'back-button') {
        const item = event.target.closest(MENU_ITEM_SELECTOR);
        const button = event.currentTarget;

        closeDropdown(item, button);
    } else {
        handleMenuLinkInteraction($this, event);
    }
}

function handleKeydown(event) {
    event.stopPropagation();
    handleKeyboardInteraction(event.currentTarget, event);
}

function handleFocus(event) {
    const $this = event.currentTarget;
    const parentItem = $this.parentElement;

    if (parentItem.classList.contains(LEVEL_1_MENU_ITEM_CLASS)) {

        if ($this.menu.$topLevelItems) {
            $this.menu.$topLevelItems.forEach(function (item) {
                const childButton = item.querySelector(MENU_BUTTON_SELECTOR);

                closeDropdown(item, childButton);
            });
        }
    }
}

function handleHover(event) {
    const $this = event.currentTarget;
    const button = $this.querySelector(MENU_BUTTON_SELECTOR);
    const headerSection = document.querySelector('.header-section');

    if (event.type === 'mouseenter') {
        setTimeout(openDropdown($this, button), 80);
        headerSection.classList.add('header--dropdown-open');
    } else {
        setTimeout(closeDropdown($this, button), 80);
        headerSection.classList.remove('header--dropdown-open');
    }
}

function handleMenuButtonInteraction(button, event) {
    event.preventDefault();

    const parentItem = button.closest(MENU_ITEM_SELECTOR);

    if (parentItem.classList.contains(OPEN_CLASS)) {
        closeDropdown(parentItem, button);
    } else {
        openDropdown(parentItem, button);

        // If we're using the slide layout and the button is top level, move focus to child
        // level back button
        if (button.source === 'mobile') {
            if (button.menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
                if (parentItem.classList.contains(LEVEL_1_MENU_ITEM_CLASS)) {
                    const backButton = parentItem.querySelector(MENU_BACK_BUTTON_SELECTOR);

                    // Delay setting the focus so that there's time for it to become visible
                    setTimeout(function () {
                        backButton.focus();
                    }, 30);
                }
            }
        }
    }
}

function handleMenuLinkInteraction(link, event) {
    const href = link.getAttribute('href');

    let path = window.location.pathname;
    let isCurrentLink = href === path;
    let isCurrentLinkOrAnchor = false;

    if (link.classList.contains(MENU_LINK_EMPTY_CLASS) || isCurrentLink) {
        isCurrentLinkOrAnchor = true;
    }

    if (isCurrentLinkOrAnchor) {
        event.preventDefault();

        if (link.source === 'mobile') {
            closeMenu(link.menu);
        } else {
            const topLevelItem = link.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
            const button = topLevelItem.querySelector(MENU_BUTTON_SELECTOR);

            closeDropdown(topLevelItem, button);
        }
    } else {
        if (event.key === ' ') {
            event.preventDefault();
            window.location.assign(href);
        }
    }
}

function handleKeyboardInteraction(element, event) {
    const key = event.key;

    if (INTERACTION_KEYS.includes(key)) {
        if (key === ' ' || key === 'Enter') {
            // If the current element is a button, toggle the dropdown
            // If it's a back button, close the current dropdown and move focus back to the parent
            // Otherwise, it's a link
            if (element.classList.contains(MENU_BUTTON_CLASS)) {
                handleMenuButtonInteraction(element, event);
            } else if (element.classList.contains(MENU_BACK_BUTTON_CLASS)) {
                const parentItem = element.closest(MENU_ITEM_SELECTOR);
                const parentButton = parentItem.querySelector(MENU_BUTTON_SELECTOR);

                parentButton.focus();
                handleMenuButtonInteraction(element, event);
            } else if (key === 'Enter') {
                handleMenuLinkInteraction(element, event);
            }
        } else if (key === 'Escape') {
            // Find the closest parent dropdown, close it, and focus the associated button
            if (element.source === 'mobile') {
                let closestOpenDropdown;

                if (element.classList.contains(MENU_BUTTON_CLASS) || element.classList.contains(MENU_BACK_BUTTON_CLASS)) {
                    closestOpenDropdown = element.closest(OPEN_MENU_ITEM_SELECTOR);
                } else {
                    closestOpenDropdown = element.closest(MENU_ITEM_SELECTOR);
                }

                if (closestOpenDropdown !== null) {
                    const button = closestOpenDropdown.querySelector(MENU_BUTTON_SELECTOR);

                    closeDropdown(closestOpenDropdown, button);
                    button.focus();
                } else {
                    closeMenu(element.menu);
                }
            } else {
                const topLevelItem = element.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
                const button = topLevelItem.querySelector(MENU_BUTTON_SELECTOR);

                closeDropdown(topLevelItem, button);
                button.focus();
            }
        } else if (key === 'Tab') {
            // If we're on mobile, using the slide layout, and inside a level 2 menu, keep tab focus
            // from leaving the menu
            if (element.source === 'mobile') {
                if (element.menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
                    const parentList = element.closest(MENU_LIST_SELECTOR);

                    if (element.menu.$hamburgerClose !== null ) {
                        const $this = event.target;
                        const focusableElements = parentList.querySelectorAll(`.${LEVEL_1_MENU_LIST_CLASS} > .header-menu__item > [tabindex="0"]`);
                        const firstFocusableElement = element.menu.$hamburgerClose;
                        const lastFocusableElement = focusableElements[focusableElements.length - 1];

                        if (event.shiftKey) {
                            if ($this === firstFocusableElement) {
                                event.preventDefault();
                                lastFocusableElement.focus();
                            }
                        } else if ($this === lastFocusableElement) {
                            event.preventDefault();
                            firstFocusableElement.focus();
                        }
                    } else if (parentList.classList.contains(LEVEL_1_MENU_LIST_CLASS)) {
                        const $this = event.target;
                        const focusableElements = parentList.querySelectorAll(`.${LEVEL_1_MENU_LIST_CLASS} > .header-menu__item > [tabindex="0"]`);
                        const firstFocusableElement = focusableElements[0];
                        const lastFocusableElement = focusableElements[focusableElements.length - 1];

                        if (event.shiftKey) {
                            if ($this === firstFocusableElement) {
                                event.preventDefault();
                                lastFocusableElement.focus();
                            }
                        } else if ($this === lastFocusableElement) {
                            event.preventDefault();
                            firstFocusableElement.focus();
                        }
                    } else if (parentList.classList.contains(LEVEL_2_MENU_LIST_CLASS)) {
                        const $this = event.target;
                        const focusableElements = parentList.querySelectorAll('[tabindex="0"]');
                        const firstFocusableElement = focusableElements[0];
                        const lastFocusableElement = focusableElements[focusableElements.length - 1];

                        if (event.shiftKey) {
                            if ($this === firstFocusableElement) {
                                event.preventDefault();
                                lastFocusableElement.focus();
                            }
                        } else if ($this === lastFocusableElement) {
                            event.preventDefault();
                            firstFocusableElement.focus();
                        }
                    }
                }
            }
        }
    }
}

function openMenu(menu) {
    menu.$body.classList.add(NO_SCROLL_CLASS);
    menu.$body.classList.add(OVERFLOW_CLASS);
    menu.$header.classList.add(OPEN_CLASS);
    menu.$hamburgerOpen.classList.add(OPEN_CLASS);
    menu.$hamburgerClose.classList.add(OPEN_CLASS);
}

function closeMenu(menu) {
    menu.$body.classList.remove(NO_SCROLL_CLASS);
    menu.$body.classList.remove(OVERFLOW_CLASS);
    menu.$header.classList.remove(OPEN_CLASS);
    menu.$hamburgerOpen.classList.remove(OPEN_CLASS);
    menu.$hamburgerClose.classList.remove(OPEN_CLASS);
    removeClassFromElements(menu.$items, OPEN_CLASS);
}

function openDropdown(item, button) {
    item.classList.add(OPEN_CLASS);
}

function closeDropdown(item, button) {
    const childList = item.querySelector(MENU_LIST_SELECTOR);
    const childListDropdownItems = childList.querySelectorAll(MENU_ITEM_SELECTOR);

    item.classList.remove(OPEN_CLASS);

    if (childListDropdownItems !== null) {
        childListDropdownItems.forEach(function (item) {
            const button = item.querySelector(MENU_BUTTON_SELECTOR);

            item.classList.remove(OPEN_CLASS);
        });
    }
}

function removeClassFromElements(elems, className) {
    elems.forEach(function (elem) {
        elem.classList.remove(className);
    });
}

function setAttributeForElements(elems, attribute, value) {
    elems.forEach(function (elem) {
        elem.setAttribute(attribute, value);
    });
}


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function () {
    const mobileMedia = window.matchMedia('(max-width: 1024px)');

    if (mobileMedia.matches) {
        initMobileMenu();
    } else {
        initDesktopMenu();
    }
});

window.addEventListener('resize', function () {
    const mobileMedia = window.matchMedia('(max-width: 1024px)');

    if (mobileMedia.matches) {
        initMobileMenu();
    } else {
        initDesktopMenu();
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const menu = {
        $body: document.querySelector('body'),
        $header: document.querySelector(HEADER_SELECTOR),
        $hamburgerOpen: document.querySelector(HAMBURGER_OPEN_SELECTOR),
        $hamburgerClose: document.querySelector(HAMBURGER_CLOSE_SELECTOR),
        $items: document.querySelectorAll(MENU_ITEM_SELECTOR),
        $buttons: document.querySelectorAll(MENU_BUTTON_SELECTOR)
    };

    // Toggle the mobile menu when the hamburger is clicked
    // Otherwise, close the menu if clicked outside of it
    menu.$body.addEventListener('click', function (event) {
        const $this = event.target;

        let hamburgerClick = false;
        let hamburger = null;

        if ($this.classList.contains(HAMBURGER_CLASS)) {
            hamburgerClick = true;
            hamburger = $this;
        } else {
            const closestHamburger = $this.closest(`.${HAMBURGER_CLASS}`);

            if (closestHamburger !== null) {
                hamburgerClick = true;
                hamburger = closestHamburger;
            }
        }

        if (hamburgerClick) {
            event.preventDefault();

            if (hamburger.classList.contains(OPEN_CLASS)) {
                closeMenu(menu);
            } else {
                openMenu(menu);
            }
        } else if ($this.closest(MENU_WRAPPER_SELECTOR) === null && $this.closest('.modal__toggle') === null) {
            closeMenu(menu);
        }
    });
});

function handleScroll() {
    const announcementBar = document.getElementById(ANNOUNCEMENT_BAR_ID);
    const header = document.querySelector(HEADER_SELECTOR);
    const searchDetails = document.querySelector('.header__search .details');
    let searchIsOpen = searchDetails?.getAttribute('open');
    let heightThreshold = 0;

    if (announcementBar) {
        heightThreshold = announcementBar.offsetHeight;
    }

    if (window.scrollY > heightThreshold) {
        header.classList.add('header--has-scroll')
    } else {
        header.classList.remove('header--has-scroll')
    }

    if (window.location.pathname === '/') {
        if (window.scrollY > heightThreshold) {
            header.classList.remove('header--transparent');
        } else {
            if (!searchIsOpen) {
                header.classList.add('header--transparent');
            }
        }
    }
}

function handleLayout2Overflow() {
    const mobileMedia = window.matchMedia('(max-width: 1024px)');

    if (!mobileMedia.matches) {
        const desktopLevel1NavItems = [...document.querySelectorAll('.header-menu__list--desktop .header-menu__item--dropdown')];
        const layout2NavItems = desktopLevel1NavItems.filter((navItem) => navItem.querySelector('.header-menu__list--layout-2'));
        const threshold = window.innerWidth * 0.4;

        layout2NavItems.forEach((navItem) => {
            const navItemRect = navItem.getBoundingClientRect();

            if (navItemRect.left >= threshold) {   
                const layout2Menu = navItem.querySelector('.header-menu__list--layout-2');
                layout2Menu.style.transform = 'translateX(-32vw)';
            }
        });
    }
}

function sizePredictiveSearch() {
    const mobileMedia = window.matchMedia('(max-width: 1024px)');
    if (mobileMedia.matches) {
        const mobilePredictiveSearch = document.querySelector('.header--mobile .predictive-search');
        const mobileSearchWrapper = document.querySelector('.header--mobile .search-modal');
        const searchWrapperRect = mobileSearchWrapper.getBoundingClientRect(); 

        mobilePredictiveSearch.style.width = `${window.innerWidth}px`;
        mobilePredictiveSearch.style.left = window.innerWidth > 750 ? `calc(-${searchWrapperRect.left}px - 1rem)` : `calc(-${searchWrapperRect.left}px)`;
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const searchModalButton = document.querySelectorAll('.header__icon.modal__toggle');
    const isProductPage = window.location.pathname.includes('/products/');

    if (isProductPage) {
        const headerSection = document.querySelector('.shopify-section--header');
        headerSection.style.position = 'relative';
    }

    searchModalButton.forEach(function (button) {
        button.addEventListener('click', function () {
            sizePredictiveSearch();
        });

        if (window.location.pathname === '/') {
            button.addEventListener('click', function () {
                const searchDetails = document.querySelector('.header__search details');
                const searchIsOpen = searchDetails?.getAttribute('open');
                const header = document.querySelector('.header');
                
                if (searchIsOpen && header.classList.contains('header--transparent')) {
                    header.classList.remove('header--transparent')
                }
            })
        }
    })
    

    window.addEventListener('resize', throttle(handleLayout2Overflow, 5));
    window.addEventListener('resize', throttle(sizePredictiveSearch, 5));
    

    if (!isProductPage) {
        window.addEventListener('scroll', throttle(handleScroll, 5));
        handleScroll();
    }

    handleLayout2Overflow();
});
